function normalizeText(value) {
  if (value === null || value === undefined) return "";
  return String(value).trim();
}

export function mapOperacionesRow(row = {}) {
  if (!row || typeof row !== "object") return row;

  const codigoTienda = row.codigoTienda ?? row.codTienda ?? null;
  const status = normalizeText(row.status ?? row.estadoOc) || "PENDIENTE";

  return {
    ...row,
    idLiquidacionCab: row.idLiquidacionCab ?? row.idLiquidacion ?? null,
    codigoTienda,
    status,
    estadoOc: normalizeText(row.estadoOc ?? row.status) || status,
    numeroOc: normalizeText(row.numeroOc),
    migo: normalizeText(row.migo),
    urlPdf: row.urlPdf || null,
    nombreArchivo: row.nombreArchivo || null,
    fechaSubidaPdf: row.fechaSubidaPdf || null,
  };
}

export function mapOperacionesResponse(response) {
  const rows = Array.isArray(response)
    ? response
    : Array.isArray(response?.items)
      ? response.items
      : Array.isArray(response?.data)
        ? response.data
        : [];

  return rows.map(mapOperacionesRow);
}
